"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildingBlockComponents = void 0;
const abstract_block_component_1 = require("./abstract-block/abstract-block.component");
const add_block_component_1 = __importDefault(require("./add-block/add-block.component"));
const block_customer_component_1 = __importDefault(require("./block-customer/block-customer.component"));
const block_dealer_component_1 = __importDefault(require("./block-dealer/block-dealer.component"));
const block_form_component_1 = __importDefault(require("./block-form/block-form.component"));
const block_input_component_1 = __importDefault(require("./block-input/block-input.component"));
const block_signature_component_1 = __importDefault(require("./block-signature/block-signature.component"));
const block_spacer_component_1 = __importDefault(require("./block-spacer/block-spacer.component"));
const block_vehicle_component_1 = __importDefault(require("./block-vehicle/block-vehicle.component"));
const block_wrapper_component_1 = __importDefault(require("./block-wrapper/block-wrapper.component"));
const column_block_component_1 = __importDefault(require("./column-block/column-block.component"));
const block_text_component_1 = __importDefault(require("./block-text/block-text.component"));
const block_title_component_1 = __importDefault(require("./block-title/block-title.component"));
const block_page_break_component_1 = __importDefault(require("./block-page-break/block-page-break.component"));
const block_vehicle_field_component_1 = __importDefault(require("./block-vehicle-field/block-vehicle-field.component"));
const block_author_component_1 = __importDefault(require("./block-author/block-author.component"));
const block_options_component_1 = __importDefault(require("./block-options/block-options.component"));
exports.BuildingBlockComponents = [
    abstract_block_component_1.AbstractBuildingBlock,
    block_title_component_1.default,
    block_form_component_1.default,
    block_text_component_1.default,
    block_wrapper_component_1.default,
    column_block_component_1.default,
    add_block_component_1.default,
    block_customer_component_1.default,
    block_dealer_component_1.default,
    block_spacer_component_1.default,
    block_input_component_1.default,
    block_vehicle_component_1.default,
    block_signature_component_1.default,
    block_page_break_component_1.default,
    block_vehicle_field_component_1.default,
    block_author_component_1.default,
    block_options_component_1.default,
];
